/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { createStandaloneToast } from "@chakra-ui/react";
import { theme } from "../_styles/theme";

export const createToast = () => {
  const toast = createStandaloneToast({ theme: theme });
  return toast;
};
